<template>
  <section class="home-section home-servicios-preferentes mb-3 mb-md-5">
    <div class="container">
      <div class="section-head mb-5">
        <div class="service-head-bg">
          <img
            src="@/assets/images/service-head-bg-4.jpg"
            alt
            class="img-fluid"
          />
        </div>
        <div class="sec-header">
          <h1 class="sec-title"><span>4.</span>Servicios <br />Preferentes</h1>
          <h2 class="sec-subtitle">
            Servicios para un óptimo
            <br />desempeño y correcta <br />gestión de mercancía.
          </h2>
          <div class="section-head-action">
            <router-link
              class="btn btn-outline-light rounded-0 font-weight-bold"
              to="/servicios"
            >
              <span>+</span> Info
            </router-link>
          </div>
        </div>
      </div>
      <div class="sec-content">
        <div class="row">
          <div class="col-md-4 sec-desc">
            <h2 class="sec-desc-title">Cross Docking</h2>
            <h3 class="sec-desc-subtitle">
              ¿Qué es el cross docking en la logística?
            </h3>
            <p class="sec-desc-cont">
              Dicho de una manera simple, el cross docking es una técnica que
              ayuda a optimizar el tiempo de almacenaje, haciéndolo inexistente
              o muy limitado. El proceso hace que la mercancía no se quede en el
              almacén o que cuando llegue, ésta salga directamente a los
              clientes.
            </p>
          </div>
          <div class="col-md-4 sec-desc">
            <h2 class="sec-desc-title">Transporte</h2>
            <h3 class="sec-desc-subtitle">Adecuado a sus necesidades.</h3>
            <p class="sec-desc-cont">
              Contar con vehículos de transporte de carga pesada y maquinaria
              adecuada para el manejo de mercancía y materiales, garantiza la
              distribución correcta, ordenada y entrega a tiempo al destino
              indicado.
            </p>
          </div>
          <div class="col-md-4 sec-desc">
            <h2 class="sec-desc-title">Personal Calificado</h2>
            <h3 class="sec-desc-subtitle">Dinámico y capacitado</h3>
            <p class="sec-desc-cont">
              Nuestro personal dinámico y altamente capacitado es un grupo de
              profesionales orientado y apasionado del ramo logístico
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeServicosPreferentes',
}
</script>
<style lang="scss" scoped>
.home-servicios-preferentes {
  .sec-desc-title {
    margin-bottom: 0;
    font-size: 2.7rem;
    line-height: 2.7rem;
  }
  .sec-desc-subtitle {
    font-size: 1.6rem;
    line-height: 1.6rem;
    font-weight: 200;
    margin-bottom: 1.5rem;
  }
}
</style>
